import type { ReactNode } from 'react';
import classes from './MarketplaceTabs.module.css';

type MarketplaceTabLabelProps = {
  icon: ReactNode;
  label: string;
  count: number;
  /** Hide label text on narrow layouts */
  hideLabel?: boolean;
};

export function MarketplaceTabLabel({
  icon,
  label,
  count,
  hideLabel,
}: MarketplaceTabLabelProps) {
  return (
    <span className={classes.tabInner}>
      <span className={classes.tabMain}>
        <span className={classes.tabIcon}>{icon}</span>
        {!hideLabel && <span className={classes.tabLabelText}>{label}</span>}
      </span>
      <span className={classes.tabCount}>{count}</span>
    </span>
  );
}
